import checkAutoplayPolicy from './checkAutoplayPolicy';
import Logger from './Logger';
import BugReporter from './BugReporter';
import createObservable from './createObservable';
import createObserver from './createObserver';
import Analytics, { Environment as AnalyticsEnvironment } from './Analytics';
var Observer = {
    createObservable: createObservable,
    createObserver: createObserver
};
export { Analytics, AnalyticsEnvironment, BugReporter, Logger, checkAutoplayPolicy, Observer };
//# sourceMappingURL=index.js.map